import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const roleBasedNotificationDetailRoute: InvariantJiraRoute = {
	name: 'eoc-role-based-notifications-detail',
	path: '/jira/settings/products/ops/role-based-notifications/:id',
	exact: true,
};
